import { render, staticRenderFns } from "./UserGroupSetup.vue?vue&type=template&id=458ee328"
import script from "./UserGroupSetup.vue?vue&type=script&lang=ts"
export * from "./UserGroupSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports